"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnkrProvider = void 0;

var _formatter = require("./formatter");

var _urlJsonRpcProvider = require("./url-json-rpc-provider");

var _logger = require("@ethersproject/logger");

var _version = require("./_version");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var logger = new _logger.Logger(_version.version);
var defaultApiKey = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";

function getHost(name) {
  switch (name) {
    case "homestead":
      return "rpc.ankr.com/eth/";

    case "ropsten":
      return "rpc.ankr.com/eth_ropsten/";

    case "rinkeby":
      return "rpc.ankr.com/eth_rinkeby/";

    case "goerli":
      return "rpc.ankr.com/eth_goerli/";

    case "matic":
      return "rpc.ankr.com/polygon/";

    case "arbitrum":
      return "rpc.ankr.com/arbitrum/";
  }

  return logger.throwArgumentError("unsupported network", "name", name);
}

var AnkrProvider = /*#__PURE__*/function (_UrlJsonRpcProvider) {
  _inherits(AnkrProvider, _UrlJsonRpcProvider);

  var _super = _createSuper(AnkrProvider);

  function AnkrProvider() {
    _classCallCheck(this, AnkrProvider);

    return _super.apply(this, arguments);
  }

  _createClass(AnkrProvider, [{
    key: "isCommunityResource",
    value: function isCommunityResource() {
      return this.apiKey === defaultApiKey;
    }
  }], [{
    key: "getApiKey",
    value: function getApiKey(apiKey) {
      if (apiKey == null) {
        return defaultApiKey;
      }

      return apiKey;
    }
  }, {
    key: "getUrl",
    value: function getUrl(network, apiKey) {
      if (apiKey == null) {
        apiKey = defaultApiKey;
      }

      var connection = {
        allowGzip: true,
        url: "https:/\/" + getHost(network.name) + apiKey,
        throttleCallback: function throttleCallback(attempt, url) {
          if (apiKey.apiKey === defaultApiKey) {
            (0, _formatter.showThrottleMessage)();
          }

          return Promise.resolve(true);
        }
      };

      if (apiKey.projectSecret != null) {
        connection.user = "";
        connection.password = apiKey.projectSecret;
      }

      return connection;
    }
  }]);

  return AnkrProvider;
}(_urlJsonRpcProvider.UrlJsonRpcProvider);

exports.AnkrProvider = AnkrProvider;